// extracted by mini-css-extract-plugin
export default {"container":"styles_container__U0xW2","sub-container":"styles_sub-container__LVLx5"};